import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
    background: #1c1c1c;
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem calc((100vw - 1000px) / 2);
    z-index: 100;
    position: relative;
`;

export const NavLink = styled(Link)`
    color: #808080;
    display: flex;
    text-align: center;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    &.active {
        color: #fe88f1;
    }
    @media screen and (max-width: 768px) {
        padding: 14px 24px;
        width: 100%;
        height: auto;
        border-bottom: 1px solid rgba(255,255,255,0.05);
        &:last-child { border-bottom: none; }
    }
`;

export const Bars = styled.div`
    display: none;
    color: #808080;
    font-size: 1.8rem;
    cursor: pointer;
    @media screen and (max-width: 768px) {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
    }
`;

export const NavMenu = styled.div`
    display: flex;
    align-items: center;
    margin-right: -24px;
    @media screen and (max-width: 768px) {
        display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
        flex-direction: column;
        align-items: flex-start;
        position: absolute;
        top: 45px;
        left: 0;
        right: 0;
        background: #1c1c1c;
        z-index: 99;
        padding: 8px 0;
        border-top: 1px solid rgba(255,255,255,0.08);
        box-shadow: 0 8px 24px rgba(0,0,0,0.4);
    }
`;

export const NavBtn = styled.nav`
    display: flex;
    align-items: center;
    margin-right: 24px;
    @media screen and (max-width: 768px) {
        display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
        margin: 8px 24px 16px;
    }
`;

export const NavBtnLink = styled(Link)`
    border-radius: 4px;
    background: #808080;
    padding: 10px 22px;
    color: #000000;
    outline: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    text-decoration: none;
    margin-left: 24px;
    &:hover {
        transition: all 0.2s ease-in-out;
        background: #fff;
        color: #808080;
    }
    @media screen and (max-width: 768px) {
        margin-left: 0;
    }
`;
